import { createActionConst } from '../../../utils/action.utils';

const PASSWORD_GROUP_NAMESPACE = 'PASSWORD_GROUP';

export const STORE_PASSWORD_GROUP = createActionConst(PASSWORD_GROUP_NAMESPACE, 'STORE_PASSWORD_GROUP');
export const CLEAR_PASSWORD_GROUP = createActionConst(PASSWORD_GROUP_NAMESPACE, 'CLEAR_PASSWORD_GROUP');
